import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useUploadCSVMutation = () => {
  return useGenericRequestHandler({
    route: `t/uploadCSV`,
    method: 'POST'
  })
}
